import React, { useEffect, useState } from 'react';

/**
 * Prerender-safe mailto link.
 *
 * Cloudflare's Email Address Obfuscation rewrites any e-mail address found in
 * served HTML into an <a href="/cdn-cgi/l/email-protection#..."> link. Crawlers
 * that don't execute JS (Ahrefs, most SEO audits) see that path as a broken
 * 404 link on every page, which tanked the site-audit health score.
 *
 * Fix: keep the address out of the prerendered HTML entirely. During the
 * react-snap snapshot (userAgent === 'ReactSnap') and during the first client
 * render (so hydration matches the snapshot) we render a neutral placeholder;
 * after mount the real mailto link appears for users.
 */

const EMAIL_USER = 'info';
const EMAIL_DOMAIN = 'fleettrackholland.nl';

export const CONTACT_EMAIL = `${EMAIL_USER}@${EMAIL_DOMAIN}`;

const isPrerender =
  typeof navigator !== 'undefined' && navigator.userAgent === 'ReactSnap';

export default function EmailLink({ className, subject, children }) {
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted || isPrerender) {
    return <span className={className}>{children || 'e‑mail ons'}</span>;
  }

  const href = subject
    ? `mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent(subject)}`
    : `mailto:${CONTACT_EMAIL}`;

  return (
    <a href={href} className={className}>
      {children || CONTACT_EMAIL}
    </a>
  );
}
